import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { faHistory, faCheckCircle, faQuestionCircle, faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { DateTime } from 'luxon';
import { CaseService } from '../../../../shared/services/case.service';
import { CreditSafecheckService } from '../../../../shared/services/credit-safecheck.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-credit-safe-check-history',
  templateUrl: './credit-safe-check-history.component.html',
  styleUrls: ['./credit-safe-check-history.component.scss']
})
export class CreditSafeCheckHistoryComponent implements OnInit {

  @Input() clientNo: number = 1;
  @Input() caseId: number = 0;

  historyData: any[] = [];
  
  faExclamationCircle = faExclamationCircle;
  faCheckCircle = faCheckCircle;

  displayedColumns: string[] = ['faStatus', 'checkResult', 'checkPerformedDate', 'checkPerformedBy', 'isManual', 'checkResultString'];


  constructor(
    private creditSafecheckService: CreditSafecheckService,
    public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.loadHistory();
  }

  loadHistory() {
    this.creditSafecheckService.getCreditSafecheckHistory(this.caseId, this.clientNo)
      .subscribe(data => {
        this.historyData = data.filter(x => x.cancelledDate != null);
      });
  }

}
